import type { BaseKeyFunction } from "../../../lib";

export type KeyRadioStationProps = { id: number };

export const keyRadioStation: BaseKeyFunction<KeyRadioStationProps> = ({
  id,
}) => ["radio-station", id?.toString()];
